module.exports = __webpack_public_path__ + "img/public/SiteIcons/incrementPlus.svg?5958e2aa";